import { lang } from "@libs/translate/translate";
const translate = {
  ru: {
    header: "Установка Warface",
  },
  en: {
    header: "Warface installation",
  },
  fr: {
    header: "Installation de Warface",
  },
  de: {
    header: "Warface installation",
  },
  pl: {
    header: "Instalacja Warface",
  },
  cn: {
    header: "Warface installation",
  },
  es: {
    header: "Warface installation",
  },
};

export function getHeader() {
  if (lang in translate) {
    return translate[lang].header;
  }
  return translate["en"].header;
}
